import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { useAlertFirings } from '../../hooks/useAdmin';
import { formatDate, sortRows, toggleDir } from './adminUtils';

export default function AdminAlertFirings() {
    const { data: firings = [], isLoading } = useAlertFirings();
    const [sort, setSort] = useState({ key: 'timestamp', dir: 'desc' });

    const sorted = sortRows(firings, sort.key, sort.dir, (r, k) => {
        if (k === 'timestamp') return r.timestamp;
        if (k === 'alert_name') return r.params?.alert_name ?? '';
        if (k === 'source') return r.params?.source ?? '';
        return '';
    });

    const sp = (key) => ({
        active: sort.key === key,
        direction: sort.key === key ? sort.dir : 'asc',
        onClick: () => setSort(prev => toggleDir(prev, key)),
    });

    if (isLoading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
    }

    return (
        <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, py: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#2c3e50', mb: 2 }}>
                Aktiviranja alertâ (zadnjih 48h)
            </Typography>
            <Paper sx={{ overflow: 'auto' }}>
                {sorted.length === 0 ? (
                    <Box sx={{ p: 2 }}>
                        <Typography color="text.secondary">Nema aktiviranja alertâ u zadnjih 48 sati.</Typography>
                    </Box>
                ) : (
                    <Table size="small" sx={{ minWidth: 1000 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 600 }}><TableSortLabel {...sp('timestamp')}>Vrijeme</TableSortLabel></TableCell>
                                <TableCell sx={{ fontWeight: 600 }}><TableSortLabel {...sp('alert_name')}>Alert</TableSortLabel></TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Članak</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}><TableSortLabel {...sp('source')}>Portal</TableSortLabel></TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Pojmovi</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Primatelji</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Tip</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sorted.map((r) => (
                                <TableRow key={r.id} hover>
                                    <TableCell sx={{ whiteSpace: 'nowrap', fontSize: 13, minWidth: 130 }}>{formatDate(r.timestamp)}</TableCell>
                                    <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>{r.params?.alert_name ?? '—'}</TableCell>
                                    <TableCell sx={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {r.params?.article_url ? (
                                            <a href={r.params.article_url} target="_blank" rel="noopener noreferrer" style={{ color: '#2980b9', fontSize: 13, textDecoration: 'none' }}>
                                                {r.params?.article_title || r.params.article_url}
                                            </a>
                                        ) : (
                                            <span style={{ fontSize: 13 }}>{r.params?.article_title ?? '—'}</span>
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: 13 }}>{r.params?.source ?? '—'}</TableCell>
                                    <TableCell sx={{ fontSize: 13 }}>{(r.params?.matched_terms ?? []).join(', ') || '—'}</TableCell>
                                    <TableCell sx={{ fontSize: 12, color: '#666' }}>{(r.params?.email_addresses ?? []).join(', ') || '—'}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <Chip
                                            label={r.params?.notification_mode === 'daily_digest' ? 'Digest' : 'Odmah'}
                                            size="small"
                                            sx={{ fontSize: 11, fontWeight: 600, backgroundColor: r.params?.notification_mode === 'daily_digest' ? '#e8f5e9' : '#e3f2fd' }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </Paper>
        </Box>
    );
}
